import { resolveDisplayImageUrl } from '../lib/assets';

export default function BookCard({ book, compact = false }) {
  const coverSrc = resolveDisplayImageUrl(book.coverUrl);
  const articleClassName = `${
    compact
      ? 'mx-auto flex h-full w-full max-w-[17.5rem] flex-col overflow-hidden rounded-[1.4rem] border border-slate-200 bg-white shadow-sm'
      : 'mx-auto flex h-full w-full max-w-[15rem] flex-col overflow-hidden rounded-[1rem] border border-slate-200 bg-white shadow-sm'
  } ${book.amazonUrl ? 'transition duration-200 hover:-translate-y-1 hover:shadow-xl' : ''}`;
  const coverWrapClassName =
    'relative aspect-[4/5] bg-[linear-gradient(135deg,_rgba(15,23,42,0.04),_rgba(0,179,184,0.06))] p-3';
  const bodyClassName = compact ? 'flex flex-1 flex-col p-4' : 'flex flex-1 flex-col p-3.5';
  const titleClassName = compact ? 'text-xl font-semibold text-slate-900' : 'text-lg font-semibold text-slate-900';
  const blurbClassName = compact
    ? 'mt-3 max-h-[6.75rem] overflow-hidden text-sm leading-6 text-slate-600'
    : 'mt-2.5 max-h-[6.5rem] overflow-hidden text-sm leading-6 text-slate-600';

  const content = (
    <article className={articleClassName}>
      <div className={coverWrapClassName}>
        {coverSrc ? (
          <div className="flex h-full items-center justify-center">
            <img
              src={coverSrc}
              alt={book.title}
              loading="lazy"
              className="h-full w-auto max-w-full object-contain"
            />
          </div>
        ) : (
          <div className="flex h-full items-center justify-center rounded-[1.25rem] bg-white/80 px-6 text-center text-lg font-semibold text-slate-500">
            {book.title}
          </div>
        )}
        {book.comingSoon && (
          <span className="absolute right-2 top-2 rounded-full bg-brand-magenta px-3 py-1 text-xs font-semibold text-white shadow-md">
            Coming soon
          </span>
        )}
      </div>
      <div className={bodyClassName}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className={titleClassName}>{book.title}</h3>
            {book.subtitle ? (
              <p className="mt-1 text-sm font-medium text-slate-500">{book.subtitle}</p>
            ) : null}
          </div>
          {book.puzzleType?.name ? (
            <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              {book.puzzleType.name}
            </span>
          ) : null}
        </div>
        <p className={blurbClassName}>{book.shortBlurb}</p>
      </div>
    </article>
  );

  if (!book.amazonUrl) {
    return content;
  }

  return (
    <a
      href={book.amazonUrl}
      target="_blank"
      rel="noreferrer"
      aria-label={`View ${book.title} on Amazon`}
      className="block h-full rounded-[1rem] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-cyan/30"
    >
      {content}
    </a>
  );
}
